/* FragranceGems — live activity popup ("salespop"). Real purchases, real cart-adds,
   real 5 star Judge.me product reviews and real 5 star Judge.me SHOP reviews from
   fg-salespop.fragrance-gems.workers.dev; nothing here invents an entry. Deferred,
   work starts after load/first interaction, fixed overlay so no CLS.

   This file is the SOURCE and is edited here directly — Shopify minifies theme JS on
   its own CDN (verified 2026-09-20: it renames variables and emits its own .js.map
   whose sourcesContent is this file), so the comments cost the visitor nothing. Served
   size must stay under 5 KB gzipped. Mirror of this file and the wider rationale:
   Documents/coding menu/fragrancegems-salespop. */
(function () {
  'use strict';

  var API = 'https://fg-salespop.fragrance-gems.workers.dev';
  /* Cadence is per viewport, not one number. On desktop the toast sits in an empty
     bottom-left corner and costs the shopper nothing, so it can come round often. On
     a phone it covers real estate directly above the sticky add-to-cart bar, so it
     stays noticeably rarer. Same 749px breakpoint as fg-mobile.css. Read live rather
     than cached, so a rotation or resize is respected.
     Desktop was 12-30s and the owner wanted it materially more often: at 7-14s,
     measured from the moment a card appears, the card is up for 5.3s and the
     corner is then quiet for 1.7-8.7s. The phone numbers are deliberately left
     alone -- there the card sits over the sticky add-to-cart bar. */
  var PHONE = matchMedia('(max-width: 749px)');
  var GAP = { phone: [25000, 60000], desktop: [7000, 14000] };
  /* The FIRST card comes sooner than the rest. It used to reuse the normal gap,
     so on desktop the shop could sit silent for up to 30 seconds -- nothing to do
     with load speed, just the timer. The opening beat is the one most visitors are
     still around for, so it gets its own shorter window. */
  var FIRST_GAP = { phone: [8000, 15000], desktop: [3000, 7000] };
  var VISIBLE_MS = 5000; // auto-dismiss
  var RECHECK_MS = 2000; // how often to retry while another popup holds the screen
  /* Nobody should see the same perfume announced over and over. The server already
     avoids two in a row; this caps how often one product may come back to THIS
     visitor before the feed has to offer something else. */
  var MAX_PER_PRODUCT = 2;
  var HIDE_KEY = 'fg_sp_off';     // visitor opted out (localStorage, no expiry)
  var SEEN_KEY = 'fg_sp_seen';    // product -> times shown this tab session
  var ATTR_KEY = 'fg_sp_attr';    // the first card of the session, then 1 once written
  /* 0 = always visible. Started at 2, then 1, on the reasoning that advertising the
     exit costs impressions. The owner went looking for it twice and could not find
     it, which settles it: an opt-out nobody can find is not really an opt-out. */
  var HIDE_AFTER_DISMISSALS = 0;

  /* Quick view, review lightbox and store panel: own asset, fetched only on a
     click, so outside the budget.

     The URL comes from Liquid (data-qv in theme.liquid) rather than being built
     here. Shopify's CDN caches per EXACT URL including the query string, so this
     used to carry a hand-maintained ?v= number -- and that bit us: v=5 was
     requested during TESTING before the new file had been uploaded, so the CDN
     pinned the OLD body to the NEW number and kept serving it. `asset_url` emits
     Shopify's own content hash for the current file, so it is always right and
     there is nothing left to forget to bump. */
  var QV_SRC = (document.currentScript && document.currentScript.dataset.qv) || '';

  /* Never on cart or checkout. */
  var main = document.getElementById('MainContent');
  var template = (main && main.dataset.template) || '';
  if (/cart|checkout/.test(template) || /\/(cart|checkouts?)(\/|$)/.test(location.pathname)) return;

  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* Per page load only: no cookie, no storage, no visitor id. */
  var pageId = Math.random().toString(36).slice(2, 12);

  /* The only things written to browser storage are this visitor's own preferences
     and state: whether they switched the popup off, how often each product has
     already been announced to them, and which card they saw first. None of it is
     an identifier, none of it is ever sent anywhere, and every access is wrapped
     because storage throws in private mode. */
  function readStore(store, key, fallback) {
    try { return JSON.parse(window[store].getItem(key)) || fallback; }
    catch (e) { return fallback; }
  }
  function writeStore(store, key, value) {
    try { window[store].setItem(key, JSON.stringify(value)); } catch (e) { /* private mode */ }
  }

  if (readStore('localStorage', HIDE_KEY, false)) return;

  var seen = readStore('sessionStorage', SEEN_KEY, {});

  function timesShown(id) { return seen[id] || 0; }
  function noteShown(id) {
    seen[id] = timesShown(id) + 1;
    writeStore('sessionStorage', SEEN_KEY, seen);
  }

  /* Anything with its own id is a REVIEW -- of a product or of the shop -- and is
     keyed by that review and capped at one: the same words from the same customer
     twice reads as a broken loop, where two different people buying the same
     perfume is two real events. */
  function keyOf(e) { return e.id ? 'r' + e.id : String(e.product_id || ''); }
  function capOf(e) { return e.id ? 1 : MAX_PER_PRODUCT; }
  function overExposed(e) { return timesShown(keyOf(e)) >= capOf(e); }

  /* ------------------------------------------------------------------ lock */

  /* One-directional mutex: we respect other popups and publish ours. */
  var OTHERS = [
    '.react-responsive-modal-root',        // EcomSend/SendWILL welcome popup
    '.jdgm-popup-widget', '.jdgm-popup',   // Judge.me corner popup (block disabled today)
    '.fg-wv-overlay.fg-wv--visible',       // in-app browser bottom sheet
    '#shopify-pc__banner',                 // consent banner: z 2000000, overlaps by 164px
    // The upsell drawer, which opens on every add-to-cart and sits at z-index
    // 2147483000 -- far above this toast. Matched on .is-open, never on the root:
    // .fg-upsell-root is always in the DOM at inset:0, so matching that would
    // block this popup permanently.
    '.fg-upsell-root.is-open'
  ];

  function onScreen(el) {
    if (!el) return false;
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < innerHeight;
  }

  var lock = window.__fgPopupLock = window.__fgPopupLock || {
    owner: null,
    busy: function () {
      if (lock.owner) return true;
      for (var i = 0; i < OTHERS.length; i++) {
        if (onScreen(document.querySelector(OTHERS[i]))) return true;
      }
      return false;
    },
    acquire: function (name) {
      if (lock.busy()) return false;
      lock.owner = name;
      return true;
    },
    release: function (name) {
      if (lock.owner === name) lock.owner = null;
    }
  };

  /* --------------------------------------------------------------- styling */

  /* Bottom-LEFT: Judge.me's tab and chat launchers own the right corners. */
  var CSS =
    // Phone sizing is the BASE; the >=750px block below steps everything up. Kept
    // deliberately small here -- on a 390px screen the card is competing with the
    // product, not with empty corner space.
    '.fg-sp{position:fixed;left:16px;bottom:calc(16px + var(--fg-sp-lift,0px) + env(safe-area-inset-bottom,0px));' +
    'z-index:1000000;width:min(320px,calc(100vw - 32px));display:flex;gap:10px;align-items:center;' +
    // A FLOOR, not a fixed height, with align-items:center spreading the slack.
    // Only the kicker varies: "Someone in the Netherlands added to cart" wraps to
    // two lines where "Bjorn P. *****" never does, which is the whole 99 -> 117px
    // gap between a review card and a bought card. Measured worst case across every
    // country name in the feed plus "Bosnia and Herzegovina": 117.4 here, 142.6 on
    // desktop, and nothing ever reached three lines. Truncating a country name or
    // padding the review kicker with a blank line both looked worse than this.
    'box-sizing:border-box;min-height:118px;' +
    'padding:9px;padding-inline-end:4px;border:1px solid #e6d5c3;border-radius:14px;background:#fff;' +
    'box-shadow:0 8px 30px rgba(74,52,40,.18);font:400 14px/1.35 inherit;color:#4a3428;text-align:left;' +
    'opacity:0;transform:translateY(12px);transition:opacity .28s ease,transform .28s ease;' +
    'contain:layout paint}' +
    // Only the hidden state blocks clicks. During the 280ms fade-OUT the card is
    // still visible and still clickable, which it must be: a click that landed in
    // that window used to silently do nothing.
    '.fg-sp[data-show="1"]{opacity:1;transform:none}' +
    '.fg-sp:not([data-show="1"]){pointer-events:none}' +
    '.fg-sp__img{width:48px;height:48px;flex:0 0 auto;border-radius:8px;object-fit:cover;background:#fff9f5}' +
    '.fg-sp__b{min-width:0;flex:1 1 auto}' +
    '.fg-sp__k{display:block;font-size:11.5px;color:#6b5a4c;margin-bottom:1px}' +
    // Two lines, never an ellipsis: the size and concentration live at the END of
    // these titles. min-height:2lh reserves the second line even when unused --
    // measured 98px vs 116px cards otherwise, so consecutive cards jumped size.
    '.fg-sp__t{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;' +
    'overflow:hidden;min-height:2lh;font-weight:600;font-size:12.5px;color:#2c1810}' +
    // Both review types quote a customer, so both get the lighter quote styling --
    // $= matches "review" and "store_review" without a second selector.
    '.fg-sp[data-type$="review"] .fg-sp__t{font-weight:400;color:#4a3428}' +
    // A store review has no product, so the card carries the shop's wordmark --
    // which must not be cropped to a square the way a bottle shot can be.
    '.fg-sp[data-type="store_review"] .fg-sp__img{object-fit:contain}' +
    '.fg-sp__s{color:#c9922f;letter-spacing:1px;font-size:12px}' +
    // One line, always. A review's meta is the product name, which on its own is
    // long enough to wrap; wrapping pushed "Hide these" onto two lines and the
    // chevron off the card, and took the card from 113px to 132px -- the height
    // jump between types that min-height:2lh exists to prevent.
    '.fg-sp__m{flex:1 1 auto;min-width:0;overflow:hidden;text-overflow:ellipsis;' +
    'white-space:nowrap;font-size:11px;color:#8a7a6c}' +
    // A visible way out. Muted and small so it never competes with the product,
    // but one plain click -- no confirm step, no re-prompt, no dark pattern.
    // position:relative is load-bearing, not cosmetic: .fg-sp__l is an absolutely
    // positioned overlay covering the whole card, and a positioned element paints
    // above non-positioned siblings regardless of DOM order. Without this the
    // overlay swallows every click meant for Hide and for the close ×.
    '.fg-sp__h{position:relative;z-index:1;flex:0 0 auto;white-space:nowrap;' +
    'border:0;background:none;padding:0 0 0 8px;' +
    'margin-left:6px;font:inherit;font-size:11px;color:#a2938a;text-decoration:underline;' +
    'cursor:pointer;border-left:1px solid #e6d5c3}' +
    '.fg-sp__h:hover{color:#6b5a4c}' +
    '.fg-sp__meta-row{display:flex;align-items:center;margin-top:2px}' +
    // 44px stays 44px however small the card gets: it is a tap target, not decoration.
    '.fg-sp__x{position:relative;z-index:1;flex:0 0 auto;align-self:flex-start;width:44px;height:44px;margin:-5px -2px 0 0;border:0;' +
    'background:none;color:#8a7a6c;font-size:18px;line-height:1;cursor:pointer;border-radius:8px}' +
    '.fg-sp__x:hover{color:#2c1810}' +
    '.fg-sp__l{position:absolute;inset:0;border-radius:14px}' +
    // The card was always tappable but nothing said so; on a phone that reads as a
    // notice to wait out. Chevron matches .fg-popup-trigger__chevron in
    // fg-mobile.css. In the meta row, so it costs the 44px close button no width.
    '.fg-sp__c{margin-left:auto;color:#c3b3a6;font-size:15px;line-height:1}' +
    '.fg-sp:active{transform:scale(.99)}' +
    '.fg-sp:active .fg-sp__c{color:#8b5a3c}' +
    // Desktop has the room, and at 340px the card read as a phone toast stranded on
    // a wide screen. Wider card, bigger thumbnail, one step up in type. The 143px
    // floor is the measured worst case here (a wrapped "added to cart" kicker), so
    // every type lands on exactly the same box.
    '@media (min-width: 750px){' +
    '.fg-sp{width:440px;left:20px;bottom:calc(20px + var(--fg-sp-lift,0px));' +
    'min-height:143px;gap:16px;padding:14px;padding-inline-end:8px}' +
    '.fg-sp__img{width:84px;height:84px;border-radius:10px}' +
    '.fg-sp__k{font-size:13px}' +
    '.fg-sp__t{font-size:15px}' +
    '.fg-sp__m,.fg-sp__h{font-size:12.5px}' +
    '}' +
    '@media (prefers-reduced-motion: reduce){.fg-sp{transition-duration:.01ms;transform:none}}';

  /* --------------------------------------------------------------- helpers */

  function ago(sec) {
    var m = Math.max(1, Math.round(sec / 60));
    if (m < 60) return m + (m === 1 ? ' minute ago' : ' minutes ago');
    var h = Math.round(m / 60);
    if (h < 24) return h + (h === 1 ? ' hour ago' : ' hours ago');
    var d = Math.round(h / 24);
    return d === 1 ? 'yesterday' : d + ' days ago';
  }

  function track(kind, entry) {
    try {
      var body = JSON.stringify({
        kind: kind,
        entry_type: entry ? entry.type : null,
        product_id: entry ? entry.product_id : null,
        page_id: pageId
      });
      navigator.sendBeacon(API + '/events/track', new Blob([body], { type: 'text/plain' }));
    } catch (e) { /* tracking must never break the page */ }
  }

  /* Like the upsell drawer's `_upsell_sources`. Only written once a cart EXISTS:
     doing it for every visitor would tag nearly every order and make the stats
     comparison meaningless. */
  var attrsWritten = false;

  function cartExists() {
    var b = document.querySelector('.cart-bubble__text-count');
    return !!(b && parseInt(b.textContent, 10) > 0);
  }

  /* FIRST card of the session wins, and it is written exactly once.

     This used to be page-scoped, and a page is the wrong unit: `attrsWritten`
     reset on every navigation, so browsing home -> product -> product fired a
     cart mutation per pageview and left `_salespop_type` describing whichever
     card happened to open the LAST page. Measured live 20 sep 2026: cart_add on
     the collection page, purchase one navigation later, for the same visitor.
     That makes the per-type revenue split close to noise.

     Holding the attributes in sessionStorage instead fixes three things at once:
     one write per session, first-touch attribution that cannot be overwritten,
     and no lost attribution when the popup is seen BEFORE a cart exists (the old
     pendingAttrs died with the page, so that case wrote nothing at all). */
  function writeAttrs(attrs) {
    if (attrsWritten) return;
    var saved = readStore('sessionStorage', ATTR_KEY, null);
    if (saved === 1) { attrsWritten = true; return; } // already written this session
    if (!saved) saved = attrs;
    if (!saved) return;
    writeStore('sessionStorage', ATTR_KEY, saved);
    if (!cartExists()) return;
    attrsWritten = true;
    writeStore('sessionStorage', ATTR_KEY, 1);
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: saved }),
      keepalive: true
    }).catch(function () {
      attrsWritten = false;
      writeStore('sessionStorage', ATTR_KEY, saved);
    });
  }

  /* Called when a cart first appears, which may be pages after the card was
     seen: writeAttrs picks the stored one up on its own. */
  window.__fgSalespopFlush = function () { writeAttrs(null); };

  /* The quick-view asset reports its own add-to-carts through here, so a
     conversion from a popup click is measurable without that file needing to know
     the endpoint or the page id. */
  window.__fgSalespopTrack = track;

  /* ------------------------------------------------------------------ view */

  var el = null, hideTimer = null, current = null, stopped = false, dismissals = 0;

  function build() {
    var s = document.createElement('style');
    s.textContent = CSS;
    document.head.appendChild(s);

    el = document.createElement('aside');
    el.className = 'fg-sp';
    /* Deliberately OUT of the accessibility tree. It was role="status" +
       aria-live="polite", which meant a screen reader announced a sales
       notification every 12-30 seconds -- an interruption, not information.
       Everything here (the product, its page, the reviews) is reachable by
       normal browsing, so nothing is lost by making the card visual-only. */
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML =
      '<a class="fg-sp__l" href="#" aria-hidden="true" tabindex="-1"></a>' +
      '<img class="fg-sp__img" alt="" decoding="async">' +
      '<div class="fg-sp__b">' +
      '<span class="fg-sp__k"></span><span class="fg-sp__t"></span>' +
      '<span class="fg-sp__meta-row"><span class="fg-sp__m"></span>' +
      '<button class="fg-sp__h" type="button" hidden>Hide these</button>' +
      '<span class="fg-sp__c" aria-hidden="true">›</span></span></div>' +
      '<button class="fg-sp__x" type="button" aria-label="Close">×</button>';
    document.body.appendChild(el);

    /* Reaching for a card that disappears after five seconds is the most likely
       way a click "does nothing". Hovering holds it open; leaving restarts the
       clock. Touch devices have no hover, so they are unaffected. */
    el.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
    el.addEventListener('mouseleave', function () {
      if (el.dataset.show === '1') hideTimer = setTimeout(hide, 1200);
    });

    el.querySelector('.fg-sp__x').addEventListener('click', function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
      track('dismiss', current);
      dismissals++;
      hide();
    });
    el.querySelector('.fg-sp__h').addEventListener('click', function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
      track('hide', current);
      writeStore('localStorage', HIDE_KEY, true);
      hide();
      if (el.parentNode) el.parentNode.removeChild(el);
      stopped = true;
    });
    el.querySelector('.fg-sp__l').addEventListener('click', function (ev) {
      if (!current) return;
      ev.preventDefault();
      track('click', current);
      var e = current;
      hide();
      openOverlay(e);
    });
  }

  var qvLoading = false;

  /* Everything opens in place rather than navigating: a store review opens the
     shop panel, a product review opens that review, a bought / added-to-cart card
     opens the product. The fallback is never a dead click -- a store review with
     no product to fall back to goes to the public reviews page. */
  function openOverlay(e) {
    var fn = e.type === 'store_review' ? '__fgStoreView'
      : e.body ? '__fgReviewView' : '__fgQuickView';
    // Both review types are addressed by their own id -- the store panel needs it
    // too, so it can show the quote that earned the click above the shop's own
    // numbers instead of replacing it with them.
    var arg = e.body ? e.id : e.handle;
    var fallback = function () {
      location.href = e.handle ? root + 'products/' + e.handle : root + 'pages/tevreden-klanten';
    };
    if (!arg) return fallback();
    if (window[fn]) return window[fn](arg);
    if (qvLoading || !QV_SRC) return fallback();
    qvLoading = true;
    var sc = document.createElement('script');
    sc.src = QV_SRC;
    sc.onload = function () {
      qvLoading = false;
      if (window[fn]) window[fn](arg); else fallback();
    };
    // Never leave a click doing nothing: if the asset fails, just navigate.
    sc.onerror = function () { qvLoading = false; fallback(); };
    document.head.appendChild(sc);
  }

  /* Measured, so a future bottom bar is handled too. */
  function lift() {
    var most = 0;
    var bars = document.querySelectorAll('.sticky-add-to-cart__bar, .fg-sticky-checkout[data-visible="true"]');
    for (var i = 0; i < bars.length; i++) {
      var b = bars[i];
      if (!onScreen(b)) continue;
      var r = b.getBoundingClientRect();
      if (r.bottom >= innerHeight - 4) most = Math.max(most, r.height + 8);
    }
    el.style.setProperty('--fg-sp-lift', most + 'px');
  }

  var VERB = { purchase: ' bought', cart_add: ' added to cart' };

  /* No price on the card, by the owner's call (20 sep 2026). The Worker still
     resolves and caches one and still sends `price_text` per locale, so turning it
     back on is a render change and nothing more -- see attachPrices() in src/index.js. */

  /* One component, four sub-templates — only the three text slots and the image
     change. Purchase/cart-add: "Someone in X bought" / product / how long ago.
     Product review: "Name ★★★★★" / the quote / which perfume. Store review: the
     same, with the shop's wordmark and "Store review · Verified customer" in place
     of a product. The branch is on whether the entry HAS a quote, not on a list of
     type names, so a fourth type needed no fourth branch. */
  function render(e, now) {
    el.dataset.type = e.type;
    var img = el.querySelector('.fg-sp__img');
    img.src = e.photo || e.image;
    img.alt = e.title;
    var k = el.querySelector('.fg-sp__k');

    if (e.body) {
      k.textContent = e.reviewer ? e.reviewer + ' ' : '';
      var stars = document.createElement('span');
      stars.className = 'fg-sp__s';
      stars.textContent = '★'.repeat(e.rating || 5);
      k.appendChild(stars);
      el.querySelector('.fg-sp__t').textContent = '“' + e.body + '”';
      el.querySelector('.fg-sp__m').textContent = e.title;
    } else {
      k.textContent = (e.flag ? e.flag + ' ' : '') +
        (e.country ? 'Someone in ' + e.country : 'Someone') + VERB[e.type];
      el.querySelector('.fg-sp__t').textContent = e.title;
      el.querySelector('.fg-sp__m').textContent = ago(Math.max(0, now - e.ts));
    }
    el.querySelector('.fg-sp__l').href = e.handle ? root + 'products/' + e.handle : '#';
  }

  function show(e, now) {
    if (!lock.acquire('salespop')) return false;
    current = e;
    render(e, now);
    lift();
    el.querySelector('.fg-sp__h').hidden = dismissals < HIDE_AFTER_DISMISSALS;
    el.dataset.show = '1';
    noteShown(keyOf(e));
    track('impression', e);
    writeAttrs({
      _salespop_seen: '1',
      _salespop_type: e.type,
      _salespop_product: String(e.product_id || '')
    });
    hideTimer = setTimeout(hide, VISIBLE_MS + (reduced ? 0 : 280));
    return true;
  }

  function hide() {
    clearTimeout(hideTimer);
    el.dataset.show = '0';
    current = null;
    lock.release('salespop');
  }

  /* ------------------------------------------------------------- cart-adds */

  /* NOT a fetch/XHR patch — RestockRocket and FoxKit already patch fetch here.
     Click/submit listener, then poll /cart.js and report only the line that really
     appeared: may under-count, can never invent an add. Sends the product ID only,
     because /cart.js titles are TRANSLATED ("Proben Service" on a German session). */
  var ADDERS = '[name="add"],.add-to-cart-button,.quick-add__button,.fg-upsell-item-add,.sbs-btn-cart';
  var polling = false;

  function readCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function lineKey(i) { return i.key || i.variant_id || i.id; }

  function qtyMap(c) {
    var m = {};
    if (c && c.items) for (var i = 0; i < c.items.length; i++) m[lineKey(c.items[i])] = c.items[i].quantity;
    return m;
  }

  function beaconAdds(before, after) {
    var sent = 0;
    for (var i = 0; i < after.items.length; i++) {
      var it = after.items[i];
      if ((before[lineKey(it)] || 0) >= it.quantity) continue;
      try {
        navigator.sendBeacon(API + '/events/cart-add', new Blob([JSON.stringify({
          product_id: String(it.product_id || '')
        })], { type: 'text/plain' }));
        sent++;
      } catch (err) { /* a beacon must never break add-to-cart */ }
    }
    return sent;
  }

  function watchCart() {
    if (polling) return;
    polling = true;
    readCart().then(function (before) {
      if (!before) { polling = false; return; }
      var was = qtyMap(before), tries = 0;
      (function again() {
        setTimeout(function () {
          readCart().then(function (after) {
            if (after && after.items && beaconAdds(was, after)) {
              polling = false;
              window.__fgSalespopFlush(); // a cart exists now; flush any pending attrs
              return;
            }
            if (++tries < 8) again(); else polling = false;
          });
        }, 350);
      })();
    });
  }

  addEventListener('click', function (ev) {
    var t = ev.target;
    if (t && t.closest && t.closest(ADDERS)) watchCart();
  }, true);
  addEventListener('submit', function (ev) {
    var f = ev.target;
    if (f && f.action && f.action.indexOf('/cart/add') > -1) watchCart();
  }, true);

  /* ------------------------------------------------------------------ loop */

  var queue = [], drift = 0;

  function fetchFeed() {
    // 20, not 12: the per-product cap below filters this list, and on a store where
    // a few bestsellers dominate recent orders a short feed can filter down to almost
    // nothing and force a refetch every round.
    // Reviews are shown in the shopper's own language where we have them: nl on
    // the .nl storefront, de on .de, English everywhere else including .eu. Read
    // from the page's own lang attribute rather than the domain, so a locale
    // served under a shared domain still gets the right pool.
    var u = API + '/popup/feed?limit=20&lang=' +
      ((document.documentElement.lang || 'en').slice(0, 2).toLowerCase());
    var pid = productIdOnPage();
    if (pid) u += '&product_id=' + pid;
    return fetch(u, { credentials: 'omit' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        queue = (d.entries || []).filter(function (e) { return !overExposed(e); });
        drift = d.now - Math.floor(Date.now() / 1000);
      })
      .catch(function () { queue = []; });
  }

  /* The buy form is authoritative: Horizon gives every product CARD a
     <product-card-link data-product-id>, so a loose query returns a recommendation. */
  function productIdOnPage() {
    var i = document.querySelector('#MainContent input[name="product-id"], #MainContent input[name="product_id"]');
    if (i && /^\d+$/.test(i.value)) return i.value;
    var m = document.querySelector('.shopify-section[id$="__main"] [data-product-id]:not(product-card-link)');
    if (m && /^\d+$/.test(m.dataset.productId)) return m.dataset.productId;
    return null;
  }

  function gap(first) {
    var table = first ? FIRST_GAP : GAP;
    var g = PHONE.matches ? table.phone : table.desktop;
    return g[0] + Math.random() * (g[1] - g[0]);
  }

  function tick() {
    if (stopped) return;
    if (document.hidden) return setTimeout(tick, RECHECK_MS);
    // Drop anything this visitor has already been shown MAX_PER_PRODUCT times.
    while (queue.length && overExposed(queue[0])) queue.shift();
    if (!queue.length) {
      return fetchFeed().then(function () {
        setTimeout(tick, queue.length ? gap() : 5 * 60000);
      });
    }
    var e = queue.shift();
    var ok = show(e, Math.floor(Date.now() / 1000) + drift);
    if (!ok) {
      // Another popup owns the screen: put it back, retry. Never stack.
      queue.unshift(e);
      return setTimeout(tick, RECHECK_MS);
    }
    setTimeout(tick, gap());
  }

  function start() {
    if (el) return;
    build();
    fetchFeed().then(function () {
      if (queue.length) setTimeout(tick, gap(true));
    });
  }

  function arm() {
    ['scroll', 'touchstart', 'mousemove', 'keydown'].forEach(function (t) {
      addEventListener(t, once, { passive: true, once: true });
    });
    if (document.readyState === 'complete') setTimeout(start, 0);
    else addEventListener('load', once, { once: true });
  }
  function once() { start(); }

  arm();
})();
